export default __webpack_public_path__ + "static/media/check.f78a6ae4.svg";